import type { SdkEventParams } from "../types";
import type { Transport } from "../transport";

/**
 * Аналитические события. Игра шлёт кастомные события
 * ("level_complete", "boss_killed", "item_bought"), платформа их агрегирует.
 *
 * Видимость: разработчику в `/dev/games/[id]/stats`, платформе в общем dashboard.
 *
 * Лимиты:
 *   - 100 событий в минуту на юзера (защита от спама)
 *   - name: до 50 символов, snake_case
 *   - properties: до 10 ключей, значения до 200 символов
 */
export function createAnalytics(t: Transport) {
  return {
    /** Послать событие. Fire-and-forget, не блокирует игру. */
    event(params: SdkEventParams): void {
      t.notify("analytics.event", params);
    },

    /**
     * Специальный helper для «прошёл уровень» — стандартизированный event
     * чтобы у всех игр были сравнимые метрики.
     */
    levelComplete(levelId: string, durationSec?: number, score?: number): void {
      this.event({
        name: "level_complete",
        properties: {
          level_id: levelId,
          ...(durationSec !== undefined ? { duration_sec: durationSec } : {}),
          ...(score !== undefined ? { score } : {}),
        },
      });
    },
  };
}

export type AnalyticsApi = ReturnType<typeof createAnalytics>;
